module.exports = __webpack_public_path__ + "static/media/1012879.40031b08.png";